import { SecurityHelper } from 'sarsaparilla';
import * as asyncUtils from 'ui-permit/shared-components/utils/async';

import * as ACTIONS from '../constants/actions';

const { postWithAuth, get, getWithAuth } = asyncUtils.apiHelpers(SecurityHelper);

const postLotteryApplication = (inventoryId, params) => {
    const {
        first_name,
        last_name,
        email,
        account_id,
        home_address: { zip_code },
    } = SecurityHelper.getAccount();

    const application = {
        first_name,
        last_name,
        email,
        zip_code,
        account_id,
        inventory_id: inventoryId,
        ...params,
    };

    if (params.id) {
        application.id = params.id;
    }

    const url = `${process.env.API}/queuelottery/lottery/${inventoryId}/enter`;
    return postWithAuth(url, application);
};

const getLotteryUrl = (inventoryId, lotteryId) => {
    const url = `${process.env.API}/queuelottery/lottery/${inventoryId}/data/${lotteryId}`;
    return get(url);
};

const getLotteriesUrl = (inventoryId) => {
    const url = `${process.env.API}/queuelottery/lottery/${inventoryId}/list`;
    return get(url);
};

const getLotteryApplicationUrl = (inventoryId, lotteryEntryId) => {
    const url = `${process.env.API}/queuelottery/lottery/${inventoryId}/application/${lotteryEntryId}`;
    return getWithAuth(url);
};

const getInventoryUrlandKey = (inventoryId, inventoryType) => {
    let url = `/permitcontent/${inventoryId}`;
    let key = 'payload';

    switch (inventoryType) {
        case 'permit':
            url = `/permitcontent/${inventoryId}`;
            key = 'payload';
            break;
        case 'campground':
            url = `/camps/campgrounds/${inventoryId}`;
            key = 'campground';
            break;
        default:
            return { url, key };
    }
    return { url, key };
};

const getUserEapLotteryStatusUrl = (lotteryId) => {
    const url = `${process.env.API}/queuelottery/user/${lotteryId}/status`;
    return getWithAuth(url);
};

export const getLottery = asyncUtils.makeAsyncAction(
    ACTIONS.GET_LOTTERY,
    (inventoryId, lotteryId) => () => getLotteryUrl(inventoryId, lotteryId),
    'payload'
);

export const getLotteries = asyncUtils.makeAsyncAction(
    ACTIONS.GET_LOTTERIES,
    (locationId) => () => getLotteriesUrl(locationId),
    'payload'
);

export const getLotteryApplication = asyncUtils.makeAsyncAction(
    ACTIONS.GET_LOTTERY_APPLICATION,
    (inventoryId, lotteryEntryId) => () =>
        getLotteryApplicationUrl(inventoryId, lotteryEntryId),
    'payload'
);

export const getInventoryContent = (inventoryId, inventoryType) => {
    const { url, key } = getInventoryUrlandKey(inventoryId, inventoryType);

    return asyncUtils.makeAsyncAction(
        ACTIONS.GET_INVENTORY_CONTENT,
        () => () => get(`${process.env.API}${url}`),
        key
    )();
};

export const getUserEapLotteryStatus = asyncUtils.makeAsyncAction(
    ACTIONS.GET_USER_EAP_LOTTERY_STATUS,
    (lotteryId) => () => getUserEapLotteryStatusUrl(lotteryId),
    'payload'
);

export const createLotteryApplication = asyncUtils.makeAsyncAction(
    ACTIONS.CREATE_LOTTERY_APPLICATION,
    (inventoryId, params) => () => postLotteryApplication(inventoryId, params),
    'payload'
);

export const updateLotteryApplication = asyncUtils.makeAsyncAction(
    ACTIONS.UPDATE_LOTTERY_APPLICATION,
    (inventoryId, params) => () => postLotteryApplication(inventoryId, params),
    'payload'
);

export const clearLotteries = asyncUtils.makeAsyncResetAction(ACTIONS.RESET_LOTTERIES);
